import axios from 'axios';

import { cartResponseSchema } from '../models/cart';

/** @see AppleRetail.Web.ApiControllers.AppleRetailBulkOrderApiController */
export async function getOrCreateCart(signal?: AbortSignal) {
	const { data } = await axios.get<unknown>('/api/shop/order', { signal });
	return cartResponseSchema.parse(data);
}

/** @see Manzanita.Web.ApiControllers.Shop.BulkOrderApiController */
export async function resetBulkOrder() {
	await axios.post('/api/bulk-order/reset');
}
